<div class="h-100 d-flex flex-column me-2">
	<a
		draggable="false"
		class="pt-1 pb-3 overflow-hidden flex-grow-1 scrollbar-gutter text-decoration-none text-dark"
		[routerLink]="rootLink"
		queryParamsHandling="merge"
		[queryParams]="{ mobileView: undefined, tab: undefined }">
		<div class="bg-gray-200 d-flex ms-2 my-2 py-1">
			<div class="img-holder img-holder-hover ms-1 img-holder-lcp">
				<div class="img">
					<lib-catalog-logo-img [catalogKey]="catalogKey" alt="catalogLogo" height="80px" width="120px" loading="eager" />
				</div>
			</div>
			<div class="ps-4 mt-1 position-relative pt-2 w-100 overflow-hidden">
				<h1 class="fw-bold text-normal mb-0 lh-normal one-line">
					{{ catalog?.title }}
				</h1>
				<div class="mt-1 text-muted two-lines">
					<span>{{ categoriesText }}</span>
				</div>
			</div>
		</div>
	</a>

	<div class="h-100 overflow-hidden">
		@if (catalog) {
			<app-catalog-tree [mobileNavigation]="true" [highlightedIds]="highlightedIds"></app-catalog-tree>
		}
	</div>
</div>
